export enum actionTypes {
    SET_IS_WIDGETS_AUTHENTICATED = 'COMMUNICATION_WIDGETS:IS_WIDGETS_AUTHENTICATED:SET'
}
